// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"887":"6d99dcb8","938":"16f6cdd3"}[chunkId] + ".chunk.css";
};